
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Votre entreprise doit-elle être présente sur Facebook ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous cherchez à gagner en visibilité sur la Toile ? Les Pages Facebook sont faites pour vous. À l’instar d’un site Internet esthétique et réactif, une landing page efficace ou encore une newsletter envoyée quotidiennement à vos clients, découvrez un puissant outil de communication pour votre entreprise.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Votre entreprise doit-elle être présente sur Facebook ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous cherchez à gagner en visibilité sur la Toile ? Les Pages Facebook sont faites pour vous. À l’instar d’un site Internet esthétique et réactif, une landing page efficace ou encore une newsletter envoyée quotidiennement à vos clients, découvrez un puissant outil de communication pour votre entreprise.",
        },
      ],
    };
  },
};
